import { ArrowRight } from '@tamagui/lucide-icons';
import { Row } from '@unistocks/components/layout/flex';
import { Anchor } from '@unistocks/components/text/link';
import { Route } from '@unistocks/features/navigation/route';
import { Link } from 'expo-router';
import React from 'react';

export type BreadcrumbsProps = {
  // TODO: Read route from active stack
  routes: Route[];
};

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ routes }) => {
  return (
    <Row alignItems="center">
      {routes.map((route, i, arr) => (
        <React.Fragment key={route.key}>
          {route.Icon ? <route.Icon size={14} color={'$headingFont'} {...route.iconProps} /> : null}
          <Link key={route.key} asChild dismissTo href={route.href}>
            <Anchor>{route.name}</Anchor>
          </Link>
          {i < arr.length - 1 ? <ArrowRight /> : null}
        </React.Fragment>
      ))}
    </Row>
  );
};

Breadcrumbs.displayName = 'Breadcrumbs';
